import { render, staticRenderFns } from "./PodcastCover.vue?vue&type=template&id=1084d0d4&scoped=true&"
import script from "./PodcastCover.vue?vue&type=script&lang=js&"
export * from "./PodcastCover.vue?vue&type=script&lang=js&"
import style0 from "./PodcastCover.vue?vue&type=style&index=0&id=1084d0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1084d0d4",
  null
  
)

export default component.exports